import Dialog from 'global/guides/Dialog'
import { hasPermission } from 'hooks/useBackendMenu'
import { useSobreavisoOutletContext } from 'pages/Sobreaviso'
import { useParams } from 'react-router-dom'
import { sobreaviso } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirSobreaviso() {
    const { id } = useParams()
    const { data } = useSobreavisoOutletContext()
    const s = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = sobreaviso.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!s) return null

    const handleSubmit = () =>
        mutateAsync(s.id, {
            onSuccess: () => {
                toast.success('Sobreaviso excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <Dialog.Root
            width="auto"
            height="auto"
            loading={isLoading}
            onSubmit={handleSubmit}
            open={hasPermission(['delete', 'Sobreaviso'])}
        >
            <Dialog.Content>
                Realmente deseja excluir o sobreaviso do horário{' '}
                {s.horarioInicial} até {s.horarioFinal}?
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton closeOnSubmit color="error">
                    Excluir
                </Dialog.Actions.PrimaryButton>
            </Dialog.Actions>
        </Dialog.Root>
    )
}
